import { SipUserAssignment } from "../../model/sipUserAssignment";
import { fetchGetJSON } from "../api-helpers";
import { apiUrls } from "../constants";

type DtoType = SipUserAssignment;

type fetchResponseType = {
  data?: DtoType;
  error?: string;
};

export type TransformedDataType = DtoType;

export type GuiResponseType = {
  data?: TransformedDataType;
  error?: string;
};

export async function getSipUserAssignments(
  sipUserAssignmentId: string
): Promise<GuiResponseType> {
  try {
    const url = apiUrls.getSipUserAssignments.replace(
      "{{id}}",
      sipUserAssignmentId
    );
    const response: fetchResponseType = await fetchGetJSON(url);
    if (response.error) {
      return { error: response.error };
    } else if (response.data) {
      const xResponseData = response.data;

      console.log("API getSipUserAssignments GUI: %o", xResponseData);
      return { data: xResponseData };
    }
    return { error: "invariant violation" };
  } catch (err) {
    console.error("Error getSipUserAssignments: %o", err);
    return { error: (err as Error).message };
  }
}
